import React, { useState } from "react";
import _ from "lodash";
import Modal from "../../../../../components/ModalPopup";
import Button from "../../../../../components/Button";
import FHIRDetails from "../../../../../components/FHIRDetails";
import styles from "../MultipleAttributeOverride.module.scss";
import PrepareOverrides from "../../MultipleAttributeOverride/PrepareOverrides";
import OverrideSummary from "../SummaryTable";
import OverrideAuditInputModal from "../../OverrideAuditInputModal";

const ConfirmMultipleAttributeOverrideModal = (
  selectedRecord,
  primaryRecords,
  attributeOverrides,
  isOpen,
  setIsOpen,
  sendOverrideRequest
) => {
  // New state for audit modal visibility
  const [showAuditModal, setShowAuditModal] = useState(false);

  // New state to keep the audit details before final submission
  const handleAuditSubmit = auditDetails => {
    // Find the primary record as before
    const record = primaryRecords.find(
      pr => `${pr.id}+${pr.meta.source}` === selectedRecord.original.id
    );
    // Prepare final payload with audit details included
    const requestPayload = {
      ...PrepareOverrides(record, attributeOverrides, auditDetails)
    };
    sendOverrideRequest(requestPayload);
    setShowAuditModal(false); // Close audit modal
    setIsOpen(false); // Close this modal
  };

  const handleConfirm = () => {
    setShowAuditModal(true); // Open audit modal
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  if (!_.isEmpty(selectedRecord)) {
    return (
      <>
        <Modal open={isOpen} onClose={() => setIsOpen(false)}>
          <div className={styles.confirmMultipleAttributeOverride}>
            <h2 style={{ textAlign: "left" }}>Summary Of Overrides</h2>
            <br />
            <h3 style={{ textAlign: "left" }}>
              {selectedRecord.original.goldenId +
                " | " +
                selectedRecord.original.source +
                " | " +
                selectedRecord.original.recordId}
            </h3>
            <br />
            <div>
              <OverrideSummary attributeOverrides={attributeOverrides} />
            </div>
            <br />
            <div className={styles.cancelButton}>
              <Button onClick={handleCancel}>Cancel</Button>
            </div>
            <div className={styles.overrideButtons}>
              <Button
                primary
                className={styles.button}
                onClick={handleConfirm}
                disabled={Object.values(attributeOverrides).every(a =>
                  _.isEmpty(a)
                )}
              >
                Confirm and Process Overrides
              </Button>
            </div>
          </div>
        </Modal>
        {/* Audit Modal */}
        <OverrideAuditInputModal
          isOpen={showAuditModal}
          onCancel={() => setShowAuditModal(false)}
          onSubmit={handleAuditSubmit}
        />
      </>
    );
  }
};

export default ConfirmMultipleAttributeOverrideModal;
